import Repository from '@/repositories/repository'

const HantecPolicyRepository = {
  async getAllHantecPolicy(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '10',
      ...queryParams
    }

    return await Repository('hantec-policies', 'page', params)
  }
}

export default HantecPolicyRepository
